export default __webpack_public_path__ + "static/media/FFFF00.725b1003.svg";